import React from 'react';
import { Button, Card, Col, Image, Row } from 'react-bootstrap';
import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import { stages } from './homeData';
import PropTypes from 'prop-types';
import { projectItems } from './homeData';

const Page2 = ({ setStage }) => {
  return (
    <Card className="shadow-none border mb-6">
      <Card.Header className="text-center">
        <p className="fs-0 fw-bold text-uppercase">Urgent appeals </p>
        <p className="mb-0">
          Would you like to add any of our current appeals to the basket
        </p>
      </Card.Header>
      <Card.Body>
        <Row className="g-3 overflow-auto" style={{ maxHeight: '550px' }}>
          {projectItems?.map(project => (
            <Col
              key={project.id}
              className="d-flex col-xxs"
              xs={6}
              sm={4}
              md={3}
            >
              <div className="border p-2 rounded-2 d-flex flex-column justify-content-between">
                <Image fluid className="w-100" src={project.image} />
                <Flex
                  justifyContent="between"
                  alignItems="center"
                  className="mt-2"
                >
                  <p className="mb-0 fw-medium fs--2">{project.projectName}</p>
                  <p className="mb-0 fw-medium fs--2">{project.value}</p>
                </Flex>
                <IconButton
                  icon="user"
                  className="fs--2 w-100 bg-soft-primary text-primary border-0 mt-2 hover-bg-primary hover-100"
                  iconClassName="me-1"
                  onClick={() => console.log(project.id)}
                >
                  Add To Cart
                </IconButton>
              </div>
            </Col>
          ))}
        </Row>
        <Flex
          justifyContent="between"
          alignItems="center"
          className={'mt-4 flex-column flex-md-row'}
        >
          <Button
            variant="default"
            className="bg-soft-secondary h-52 hover-bg-primary hover-100 w-215px"
            onClick={() => setStage(stages.Donation1)}
          >
            Back
          </Button>
          <Button
            className="h-52 w-215px mt-3 mt-md-0"
            onClick={() => setStage(stages.Donation3)}
          >
            Skip
          </Button>
        </Flex>
      </Card.Body>
    </Card>
  );
};

Page2.propTypes = {
  setStage: PropTypes.func.isRequired
};

export default Page2;
